import {drawStroke} from "./strokePainter";
import {fillHoles} from "./fillHoles";
import {fabric} from "fabric";

export function updateMask(dieCut, callback) {
    let app = dieCut;
    let store = dieCut.store;
    let canvas = store.canvas;

    if (app.loading || app.manipulatingObject) {
        return;
    }

    app.loading = true;

    store.setLoading('processing.dieCut_updateMask', '');


    getDataURL({canvas, store, dieCut, callback: function (dataURL) {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = 300 * store.width;
        tempCanvas.height = 300 * store.height;
        const ctx = tempCanvas.getContext('2d', { willReadFrequently: true });
        const img = new Image();

        img.src = dataURL;

        img.onload = function() {
            ctx.drawImage(img, 0, 0);

            let imageData = ctx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
            drawStroke(ctx, imageData, app.strokeWidth);

            imageData = ctx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
            fillHoles(ctx, imageData);

            const canvasImageURL = tempCanvas.toDataURL();

            let width = Number.parseFloat(store.width);
            let height = Number.parseFloat(store.height);

            let maskCutoff = new fabric.Rect({fill: 'white',
                width: width * 300,
                height: height * 300,
                originX: 'center',
                originY: 'center',
                absolutePositioned: true,});

            fabric.Image.fromURL(canvasImageURL, function(img) {
                store.setLoadingFinished('processing.dieCut_updateMask');
                app.loading = false;

                img.set({
                    originX: 'center',
                    originY: 'center',
                    clipPath: maskCutoff,
                });

                if (app.manipulatingObject) return;

                canvas.set({
                    clipPath: img,
                    backgroundColor: store.bg_color,
                    backgroundImage: app.store.bg_image,
                });

                canvas.forEachObject(function(object) {
                    object.setCoords();
                });

                canvas.requestRenderAll();

                app.cutoffBorder.drawCutoffBorder({square: maskCutoff});
            });
        };
    }});
}

function getDataURL({canvas, store, width = null, height = null, dieCut, callback} = {}) {
    let oldWidth = canvas.getWidth();
    let oldHeight = canvas.getHeight();
    let oldViewportTransform = canvas.viewportTransform;

    let newWidth = store.width * 300; //300 dpi
    let newHeight = store.height * 300;

    newWidth = width ? width : newWidth;
    newHeight = height ? height : newHeight;

    window.imageEditor.changeCanvasSize({canvas, newWidth, newHeight, silent: true})
    canvas.zoomToMask({store: store});

    canvas.set({
        backgroundColor: null,
        clipPath: null,
        backgroundImage: null,
    });

    const dataURL = canvas.toDataURL({
        format: 'png',
        multiplier: 1
    });

    window.imageEditor.changeCanvasSize({canvas, newWidth: oldWidth, newHeight: oldHeight, silent: true});

    canvas.viewportTransform = oldViewportTransform;
    canvas.requestRenderAll();

    if (callback) {
        callback(dataURL);
    }
}
